@if (this.cancellable) {
  <tp-button type="button" [height]="height" [enabled]="cancelEnabled" [buttonStyle]="cancelButtonStyle" (click)="onCancel()" [buttonId]="buttonIdPrefix + '_cancel'">{{ cancelText }}</tp-button>
}
<tp-button type="submit" [height]="height" [enabled]="submitEnabled" [buttonStyle]="submitButtonStyle" (click)="onSubmit()" [buttonId]="buttonIdPrefix + '_submit'" [class]="isSubmitting ? 'submitting' : ''">
  @if (isSubmitting) {<tp-spinner [size]="20"/>}
  <span>{{ submitText }}</span>
</tp-button>
